module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/fr.9acf608f.png";